"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeConversionTagging = exports.initializePageVisitTagging = exports.composeAndHashEmail = exports.injectConversionTagging = exports.injectScript = exports.injectPageVisitTagging = exports.composeCjPageType = exports.requestContainsCjQueryParams = exports.hasCjeventCookie = void 0;
var constants_1 = require("../constants");
var cookies_1 = require("../cookies");
var utils_1 = require("../utils");
var country_to_iso_1 = require("country-to-iso");
function hasCjeventCookie(request) {
    var _a, _b;
    var allCookies = (0, cookies_1.getRequestCookies)(request);
    return (_b = (_a = Object.keys(allCookies)) === null || _a === void 0 ? void 0 : _a.includes(constants_1.CJ_COOKIE_NAME)) !== null && _b !== void 0 ? _b : false;
}
exports.hasCjeventCookie = hasCjeventCookie;
function requestContainsCjQueryParams(request) {
    var fullUrl = (0, utils_1.buildFullUrlFromRequest)(request);
    return new URL(fullUrl).searchParams.has(constants_1.CJ_QUERY_NAME);
}
exports.requestContainsCjQueryParams = requestContainsCjQueryParams;
function composeCjPageType(pageType) {
    var cjPageType = "";
    if (pageType) {
        var defaultPageTypes = ["home", "category", "sub-category", "pdp", "search"];
        if (pageType.startsWith("g") || !defaultPageTypes.includes(pageType)) {
            cjPageType = "department";
        }
        else {
            var cjPageTypeMap = {
                "home": "homePage",
                "category": "category",
                "sub-category": "subCategory",
                "pdp": "productDetails",
                "search": "searchResults",
            };
            cjPageType = cjPageTypeMap[pageType] || "department";
        }
    }
    return cjPageType;
}
exports.composeCjPageType = composeCjPageType;
function injectPageVisitTagging(storeCode) {
    var tagId = storeCode.toLowerCase() === "us" ? constants_1.CJ_VALUES.US_TAG_ID : constants_1.CJ_VALUES.EU_TAG_ID;
    var scriptUrl = "https://www.mczbf.com/tags/".concat(tagId, "/tag.js");
    if (window.cj && window.cj.sitePage && Object.keys(window.cj.sitePage).length > 0) {
        injectScript(scriptUrl, constants_1.CJ_VALUES.SCRIPT_ID);
    }
}
exports.injectPageVisitTagging = injectPageVisitTagging;
function injectScript(scriptUrl, id) {
    var cjScript = document.createElement("script");
    cjScript.src = scriptUrl;
    cjScript.type = "text/javascript";
    cjScript.async = true;
    cjScript.id = id;
    var documentHead = document.getElementsByTagName("head")[0];
    if (documentHead && documentHead && documentHead) {
        documentHead.appendChild(cjScript);
    }
}
exports.injectScript = injectScript;
function injectConversionTagging(storeCode) {
    var tagId = storeCode.toLowerCase() === "us" ? constants_1.CJ_VALUES.US_TAG_ID : constants_1.CJ_VALUES.EU_TAG_ID;
    var scriptUrl = "https://www.mczbf.com/tags/".concat(tagId, "/tag.js");
    if (window.cj && window.cj.order && Object.keys(window.cj.order).length > 0) {
        injectScript(scriptUrl, constants_1.CJ_VALUES.SCRIPT_ID);
    }
}
exports.injectConversionTagging = injectConversionTagging;
function composeAndHashEmail(email) {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!email) return [3, 2];
                    return [4, (0, utils_1.sha256)((0, utils_1.removeLeadingAndTrailingSpaces)(email.toLowerCase()))];
                case 1:
                    _a = _b.sent();
                    return [3, 3];
                case 2:
                    _a = "";
                    _b.label = 3;
                case 3: return [2, _a];
            }
        });
    });
}
exports.composeAndHashEmail = composeAndHashEmail;
function initializePageVisitTagging(values, storeCode) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var emailValue, enterpriseId, sitePage, refinedSitePage;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4, composeAndHashEmail((_a = values.email) !== null && _a !== void 0 ? _a : "")];
                case 1:
                    emailValue = _c.sent();
                    enterpriseId = storeCode.toLowerCase() === "us" ? constants_1.CJ_VALUES.US_ENTERPRISE_ID : constants_1.CJ_VALUES.EU_ENTERPRISE_ID;
                    sitePage = {
                        enterpriseId: enterpriseId,
                        pageType: composeCjPageType(values.pageType),
                        userId: (values === null || values === void 0 ? void 0 : values.userId) || "",
                        emailHash: emailValue,
                        referringChannel: (values === null || values === void 0 ? void 0 : values.referringChannel) || constants_1.CJ_VALUES.REFERRING_CHANNEL,
                        items: values.items,
                        cartSubtotal: values.cartSubtotal,
                    };
                    refinedSitePage = Object.fromEntries(Object.entries(sitePage).filter(function (_a) {
                        var _b = __read(_a, 2), value = _b[1];
                        return value !== null && value !== undefined;
                    }));
                    if (((_b = (0, cookies_1.getDocumentCookies)()) === null || _b === void 0 ? void 0 : _b.cje) && (global === null || global === void 0 ? void 0 : global.window)) {
                        global.window.cj = __assign(__assign({}, window.cj), { sitePage: refinedSitePage });
                    }
                    return [2];
            }
        });
    });
}
exports.initializePageVisitTagging = initializePageVisitTagging;
function initializeConversionTagging(values, storeCode) {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function () {
        var emailValue, enterpriseId, trackerId, conversionData;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4, composeAndHashEmail((_a = values.email) !== null && _a !== void 0 ? _a : "")];
                case 1:
                    emailValue = _e.sent();
                    enterpriseId = storeCode.toLowerCase() === "us" ? constants_1.CJ_VALUES.US_ENTERPRISE_ID : constants_1.CJ_VALUES.EU_ENTERPRISE_ID;
                    trackerId = storeCode.toLowerCase() === "us" ? constants_1.CJ_VALUES.US_ACTION_TRACKER_ID : constants_1.CJ_VALUES.EU_ACTION_TRACKER_ID;
                    conversionData = {
                        enterpriseId: enterpriseId,
                        pageType: constants_1.CJ_VALUES.CONVERSION_PAGE_TYPE,
                        userId: values.userId,
                        emailHash: emailValue,
                        orderId: values.orderId,
                        actionTrackerId: trackerId,
                        currency: values.currency,
                        amount: Number((values.amount / 100).toFixed(2)),
                        discount: Number((values.discount / 100).toFixed(2)),
                        coupon: values.coupon,
                        cjeventOrder: ((_b = (0, cookies_1.getDocumentCookies)()) === null || _b === void 0 ? void 0 : _b.cje) || "",
                        customerCountry: (0, country_to_iso_1.countryToAlpha3)(values.customerCountry) || values.customerCountry,
                        brand: values.brand,
                        category: values.category,
                        items: (_c = values.items) === null || _c === void 0 ? void 0 : _c.map(function (item) {
                            return __assign(__assign({}, item), { unitPrice: Number((item.unitPrice / 100).toFixed(2)) });
                        }),
                    };
                    if (((_d = (0, cookies_1.getDocumentCookies)()) === null || _d === void 0 ? void 0 : _d.cje) && (global === null || global === void 0 ? void 0 : global.window)) {
                        window.cj = __assign(__assign({}, window.cj), { order: conversionData });
                    }
                    injectConversionTagging(storeCode);
                    return [2];
            }
        });
    });
}
exports.initializeConversionTagging = initializeConversionTagging;
//# sourceMappingURL=index.js.map